(function () {
  'use strict';

  var CODE = 'SUMMER15';
  var STORAGE_KEY = 'modo_summer15_popup_dismissed';
  var DISMISS_DAYS = 7;
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0600/3920/0943/files/modo-wordmark-white.png?v=1777910714';

  // ─── Helpers ────────────────────────────────────────────

  function isDismissed() {
    try {
      var val = sessionStorage.getItem(STORAGE_KEY);
      if (!val) return false;
      return Date.now() < JSON.parse(val).expiry;
    } catch (e) { return false; }
  }

  function setDismissed() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        expiry: Date.now() + DISMISS_DAYS * 86400000
      }));
    } catch (e) {}
  }

  function copyCode(btn) {
    var original = btn.textContent;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(CODE).then(function () {
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = original; }, 2000);
      });
    } else {
      var el = document.createElement('textarea');
      el.value = CODE;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = original; }, 2000);
    }
  }

  // ─── Popup ───────────────────────────────────────────────

  function injectPopupStyles() {
    if (document.getElementById('modo-popup-styles')) return;
    var s = document.createElement('style');
    s.id = 'modo-popup-styles';
    s.textContent = [
      '#modo-summer-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:9998;display:flex;align-items:center;justify-content:center;animation:mpFadeIn 0.3s ease;}',
      '@keyframes mpFadeIn{from{opacity:0}to{opacity:1}}',
      '@keyframes mpSlideUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}',
      '#modo-summer-popup{background:#fff;border-radius:16px;max-width:420px;width:calc(100% - 40px);box-shadow:0 20px 60px rgba(0,0,0,0.25);overflow:hidden;animation:mpSlideUp 0.35s ease;position:relative;}',
      '.mp-top{background:linear-gradient(135deg,#111 0%,#333 100%);padding:32px 32px 28px;text-align:center;}',
      '.mp-logo{display:block;height:28px;width:auto;margin:0 auto 20px;object-fit:contain;}',
      '.mp-offer{font-size:52px;font-weight:800;color:#fff;line-height:1;letter-spacing:-2px;font-family:inherit;}',
      '.mp-sub{font-size:14px;color:rgba(255,255,255,0.7);margin-top:8px;}',
      '.mp-bottom{padding:24px 32px 28px;}',
      '.mp-label{font-size:11px;font-weight:600;letter-spacing:2px;color:#aaa;text-transform:uppercase;margin-bottom:10px;}',
      '.mp-row{display:flex;align-items:center;gap:10px;margin-bottom:16px;}',
      '.mp-code-box{flex:1;background:#f5f5f5;border:2px dashed #ddd;border-radius:8px;padding:11px 14px;font-size:19px;font-weight:800;letter-spacing:4px;text-align:center;color:#000;font-family:monospace;}',
      '.mp-copy-btn{background:#000;color:#fff;border:none;border-radius:8px;padding:12px 16px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background 0.2s;font-family:inherit;}',
      '.mp-copy-btn:hover{background:#333;}',
      '.mp-note{font-size:12px;color:#aaa;text-align:center;}',
      '.mp-close{position:absolute;top:12px;right:14px;background:rgba(255,255,255,0.15);border:none;color:#fff;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:18px;line-height:1;display:flex;align-items:center;justify-content:center;transition:background 0.2s;}',
      '.mp-close:hover{background:rgba(255,255,255,0.3);}',
      '@media(max-width:480px){.mp-offer{font-size:40px;}.mp-top{padding:24px 20px 20px;}.mp-bottom{padding:20px 20px 24px;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function createPopup() {
    if (document.getElementById('modo-summer-overlay') || isDismissed()) return;
    injectPopupStyles();

    var overlay = document.createElement('div');
    overlay.id = 'modo-summer-overlay';
    overlay.innerHTML = [
      '<div id="modo-summer-popup">',
        '<div class="mp-top">',
          '<button class="mp-close" id="mp-close" aria-label="Close">&times;</button>',
          '<img class="mp-logo" src="' + LOGO_URL + '" alt="MODO" />',
          '<div class="mp-offer">15% OFF</div>',
          '<div class="mp-sub">Your entire order &mdash; no minimum required</div>',
        '</div>',
        '<div class="mp-bottom">',
          '<div class="mp-label">Your discount code</div>',
          '<div class="mp-row">',
            '<div class="mp-code-box">' + CODE + '</div>',
            '<button class="mp-copy-btn" id="mp-copy">Copy Code</button>',
          '</div>',
          '<div class="mp-note">Apply at checkout &middot; Valid on all products</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(overlay);

    document.getElementById('mp-close').addEventListener('click', function () {
      setDismissed();
      overlay.remove();
    });
    document.getElementById('mp-copy').addEventListener('click', function () {
      copyCode(this);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { setDismissed(); overlay.remove(); }
    });
  }

  // ─── Price Badge ─────────────────────────────────────────

  function injectPriceBadgeStyles() {
    if (document.getElementById('modo-badge-styles')) return;
    var s = document.createElement('style');
    s.id = 'modo-badge-styles';
    s.textContent = [
      '#modo-price-badge{display:inline-flex;align-items:center;gap:8px;background:#fafafa;border:1.5px solid #e8e8e8;border-radius:8px;padding:7px 14px;font-size:13px;font-weight:600;color:#222;cursor:pointer;transition:border-color 0.2s,background 0.2s;margin-top:4px;}',
      '#modo-price-badge:hover{border-color:#ccc;background:#f0f0f0;}',
      '#modo-price-badge .mpb-code{background:#111;color:#fff;border-radius:5px;padding:2px 9px;font-size:11px;letter-spacing:2px;font-weight:700;margin:0 2px;}',
      '#modo-price-badge .mpb-copied{color:#333;font-size:12px;margin-left:4px;opacity:0;transition:opacity 0.3s;}',
      '#modo-price-badge .mpb-copied.show{opacity:1;}'
    ].join('');
    document.head.appendChild(s);
  }

  function createPriceBadge() {
    if (document.getElementById('modo-price-badge')) return;
    injectPriceBadgeStyles();

    var badge = document.createElement('div');
    badge.id = 'modo-price-badge';
    badge.setAttribute('role', 'button');
    badge.setAttribute('title', 'Click to copy code');
    badge.innerHTML = [
      '<span>&#127881; Use code</span>',
      '<span class="mpb-code">' + CODE + '</span>',
      '<span>for <strong>15% off</strong></span>',
      '<span class="mpb-copied" id="mpb-copied">&#10003; Copied!</span>'
    ].join('');

    badge.addEventListener('click', function () {
      var copied = document.getElementById('mpb-copied');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(CODE).then(function () {
          copied.classList.add('show');
          setTimeout(function () { copied.classList.remove('show'); }, 2000);
        });
      } else {
        var el = document.createElement('textarea');
        el.value = CODE;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        copied.classList.add('show');
        setTimeout(function () { copied.classList.remove('show'); }, 2000);
      }
    });

    var targets = [
      document.querySelector('.price__container'),
      document.querySelector('[class*="price__regular"]'),
      document.querySelector('.product__price'),
      document.querySelector('[data-product-price]'),
      document.querySelector('.price')
    ];

    for (var i = 0; i < targets.length; i++) {
      if (targets[i]) {
        var ref = targets[i].closest('[class*="price"]') || targets[i];
        ref.parentNode.insertBefore(badge, ref.nextSibling);
        return;
      }
    }

    var form = document.querySelector('product-form, .product-form, [class*="product-form"]');
    if (form) form.insertBefore(badge, form.firstChild);
  }

  // ─── Init ────────────────────────────────────────────────

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function init() {
    if (isProductPage()) createPriceBadge();
    if (!isDismissed()) setTimeout(createPopup, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
